<meta charset="“UTF-8”" />
<div class="row" *ngIf="!isInfo.isPrenium && isInfo.isLoggedIn">
  <div
    class="col-md-12 my-1 p-2"
    style="
      cursor: pointer;
      text-align: center;
      background-color: #0055a4;
      color: white;
    "
    routerLink="/premium"
  >
    <h6>
      <img [src]="notprenium" /> Click here to receive <b>5 postcards</b> from
      <b>5 French cities</b> and <b>1 postcard medal</b> at the end of the
      adventure <img [src]="notprenium" />
    </h6>
  </div>
</div>

<nav class="navbar navbar-light white scrolling-navbar mb-5">
  <div class="topnav-left">
    <a class="navbar-brand" routerLink="/dashboard">
      <img
        src="../assets/images/france.png"
        width="30"
        height="30"
        class="d-inline-block align-top"
        alt=""
      />
      VirtualRacesFrance {{ version }}
    </a>
    <a mat-button routerLink="/" class="m-2" *ngIf="!isInfo.isLoggedIn"
      ><h6>Homepage</h6></a
    >
    <a mat-button routerLink="/dashboard" [disabled]="true" class="m-2"
      ><h6>Dashboard</h6></a
    >
    <a
      mat-button
      routerLink="/premium"
      class="m-2"
      *ngIf="!isInfo.isPrenium && isInfo.isLoggedIn"
      ><h6>Premium</h6></a
    >
    <a
      mat-button
      [routerLink]="['/premium']"
      [queryParams]="{ type: 'gift' }"
      class="m-2"
      *ngIf="!isInfo.isPrenium"
      [disabled]="true"
      ><h6>Gift activation</h6></a
    >
  </div>
  <div class="topnav-right">
    <span *ngIf="typeAction == 'mailparam'" class="p-3">
      <button
        mat-raised-button
        *ngIf="resultSubscribeEmail"
        color="accent"
        class="m-2"
      >
        You subscribed to email. <mat-icon>done</mat-icon>
      </button>
      <button
        mat-raised-button
        *ngIf="!resultSubscribeEmail"
        color="accent"
        class="m-2"
      >
        You unsubscribe to email. <mat-icon>done</mat-icon>
      </button>
    </span>
    <span *ngIf="typeAction == 'confirm'" class="p-3">
      <span *ngIf="!resultConfirmEmail"></span>
      <button
        mat-raised-button
        *ngIf="resultConfirmEmail"
        color="accent"
        class="m-2"
      >
        Your email address has been verified. <mat-icon>done</mat-icon>
      </button>
      <button
        mat-raised-button
        *ngIf="!resultConfirmEmail"
        color="warn"
        class="m-2"
      >
        Email confirmation: An error occured please try again later or contact
        support. <mat-icon>highlight_off</mat-icon>
      </button>
    </span>
    <span *ngIf="isInfo.isLoggedIn">
      <button
        mat-raised-button
        *ngIf="isInfo.isStravaConnected"
        class="m-2 no-click"
        color="accent"
      >
        Strava is connected <mat-icon>sync</mat-icon>
      </button>

      <button
        mat-raised-button
        *ngIf="isInfo.isPrenium"
        class="m-2"
        color="accent"
        matTooltip="You are premium user"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span>
          <img [src]="prenium" />
        </span>
      </button>

      <app-newactivity></app-newactivity>
    </span>

    <span>
      <button
        mat-raised-button
        *ngIf="!isInfo.isLoggedIn"
        routerLink="/login"
        class="m-2"
        [disabled]="true"
      >
        Sign In
      </button>
    </span>
    <span>
      <button
        mat-raised-button
        *ngIf="!isInfo.isLoggedIn"
        [disabled]="true"
        routerLink="/register"
        mat-raised-button
        color="accent"
        class="m-2"
      >
        Create account
      </button>
    </span>
    <span>
      <button
        mat-raised-button
        *ngIf="isInfo.isLoggedIn"
        routerLink="/settings"
        class="m-2"
      >
        Settings <mat-icon>settings</mat-icon>
      </button>
    </span>
    <span>
      <button
        mat-raised-button
        *ngIf="isInfo.isLoggedIn"
        (click)="logOut()"
        class="m-2"
      >
        Log Out
      </button>
    </span>
  </div>
</nav>

<nav
  class="navbar navbar-light scrolling-navbar mb-5"
  style="background-color: #0055a4; color: white; text-align: center"
>
  <b>
    You have been more than a thousand to run our races across france, the
    adventure is now over. Hope you enjoyed your runs with us. Stay tuned for
    our next adventures. For now if you have inquieries contact us by email
    (virualracesfrance@gmail.com)</b
  >
</nav>

<router-outlet></router-outlet>
